import { motion } from "framer-motion";
import { useContent } from "@/lib/content";

const reveal = {
  hidden: { opacity: 0, y: 40 },
  show: (i) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.7, delay: i * 0.1, ease: [0.16, 1, 0.3, 1] },
  }),
};

export default function Manifesto() {
  const { t } = useContent();
  const CHAPTERS = [
    { n: "01", title: t("manifesto_ch1_title"), body: t("manifesto_ch1_body") },
    { n: "02", title: t("manifesto_ch2_title"), body: t("manifesto_ch2_body") },
    { n: "03", title: t("manifesto_ch3_title"), body: t("manifesto_ch3_body") },
  ];
  return (
    <section
      data-testid="manifesto-section"
      className="bg-[#F2EFEB] text-[#090909] px-4 md:px-8 py-24 md:py-32"
    >
      <motion.p
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        className="overline text-[#FF2A00] mb-12"
      >
        {t("manifesto_label")}
      </motion.p>

      <div className="grid grid-cols-1 gap-0 border-t-2 border-[#090909]">
        {CHAPTERS.map((c, i) => (
          <motion.div
            key={c.n}
            custom={i}
            variants={reveal}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true, margin: "-80px" }}
            className="grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-8 py-10 md:py-14 border-b-2 border-[#090909] group"
          >
            <div className="md:col-span-2">
              <span className="font-mono-ui text-2xl md:text-4xl group-hover:text-[#FF2A00] transition-colors">
                {c.n}
              </span>
            </div>
            <h3 className="md:col-span-5 font-serif-ed italic text-3xl md:text-5xl leading-tight">
              {c.title}
            </h3>
            <p className="md:col-span-5 font-mono-ui text-sm md:text-base leading-relaxed self-end max-w-md">
              {c.body}
            </p>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
